"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeCreative = void 0;
const Creative_1 = require("../entity/Creative");
const creativeFastStart_1 = require("./creativeFastStart");
const file_1 = require("./file");
const createSomeCreative = ({ id = '123', fastStart = creativeFastStart_1.createSomeCreativeFastStart(), file = file_1.createSomeFile(), } = {}) => new Creative_1.default({ id, fastStart, file });
exports.createSomeCreative = createSomeCreative;
